import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Button, EmptyState } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { PathNames } from 'constants/General'
import { ActionIds } from 'types/types'
import { formatAPY } from '../utils/utils'

interface EarnNoWalletsProps {
  featuredProduct: {
    currency: string
    earningRate: number
  }
}

export const EarnNoWallets = ({ featuredProduct }: EarnNoWalletsProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleAddWallet = () => {
    void navigate(`${PathNames.WALLETS}?action=${ActionIds.WALLET_CREATE}`)
  }

  return (
    <EmptyState
      testId="earn-assets-no-wallets-empty-state"
      lottieName="welcome"
      title={t('earn.noWalletsState.title', {
        currencies: featuredProduct.currency,
        maxAPY: formatAPY(featuredProduct.earningRate),
      })}
      description={
        <>
          {t('earn.noWalletsState.description', {
            currencies: featuredProduct.currency,
          })}
          <ExternalLink href={process.env.REWARDS_HOW_IT_WORKS_URL ?? ''} target="_blank">
            {t('earn.howItWorksLink')}
          </ExternalLink>
        </>
      }
      PrimaryButton={
        <Button onClick={handleAddWallet}>
          {t('earn.noWalletsState.addWallet', { currency: featuredProduct.currency })}
        </Button>
      }
    />
  )
}
